export const GET_DMX_PROFILES = 'GET_DMX_PROFILES';
export const GET_DMX_PROFILES_SUCCESS = 'GET_DMX_PROFILES_SUCCESS';
export const GET_DMX_PROFILES_ERROR = 'GET_DMX_PROFILES_ERROR';
